
import { FunnelsServices } from "@/services";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      funnelId: ""
    };
  },
  methods: {
    async downgradeFunnel() {
      try {
        if (this.funnelId) {
          const { data } = await FunnelsServices.downgradeFunnel({ funnelId: this.funnelId });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
});
